import { AppLocalizationKey, BenefitsPayload } from '~/common/types/types';
import { generateItems } from '~/helpers/helpers';

const ITEMS_COUNT = 5;

const benefitsPayload: BenefitsPayload = {
  title: 'benefits.title',
  items: generateItems(ITEMS_COUNT, (idx) => ({
    title: `benefits.group${idx}.title` as AppLocalizationKey,
    description: `benefits.group${idx}.description` as AppLocalizationKey,
    decorationKey: idx + 1,
  })),
  registrationBtn: 'benefits.button',
};

export { benefitsPayload };
